import type { components } from '@/generated/internal-api/openapi-types';
import { _notNil } from '@/littledash';

export type CascadeDeleteChildType = 'samples' | 'measurements' | 'observations' | 'dosages';

export type CascadeDeleteOptions = Record<CascadeDeleteChildType, boolean>;

export type CascadeDeleteItemCounts = components['schemas']['AnimalCascadeDeleteItemCountV1.schema'];

export interface CageCascadeDeleteOptions extends CascadeDeleteOptions {
  animals: boolean;
}

export type CascadeDeleteParentType = 'animal' | 'cage';

export type CascadeDeleteSelection = CascadeDeleteOptions & Partial<Pick<CageCascadeDeleteOptions, 'animals'>>;

export const CASCADE_DELETE_CHILD_OPTIONS: Array<[CascadeDeleteChildType, string]> = [
  ['samples', 'Samples'],
  ['measurements', 'Measurements'],
  ['observations', 'Observations'],
  ['dosages', 'Dosages'],
];

export const UNCHECKED_CASCADE_DELETE_OPTIONS: CascadeDeleteOptions = {
  samples: false,
  measurements: false,
  observations: false,
  dosages: false,
};

export const EMPTY_CASCADE_DELETE_ITEM_COUNTS: CascadeDeleteItemCounts = {
  samples: 0,
  measurements: 0,
  observations: 0,
  dosages: 0,
};

export const hasSelectedCascadeOption = (cascade?: CascadeDeleteOptions): boolean =>
  _notNil(cascade) && CASCADE_DELETE_CHILD_OPTIONS.some(([name]) => cascade[name]);

export const UNCHECKED_CAGE_CASCADE_DELETE_OPTIONS: CageCascadeDeleteOptions = {
  animals: false,
  ...UNCHECKED_CASCADE_DELETE_OPTIONS,
};
